import { Box, Flex, Image, Progress } from "@mantine/core";
import { useEffect, useState } from "react";

const ImageShow = function ({
  img,
  w,
  h,
  loading,
}: {
  img: string;
  w: number | undefined;
  h: number | undefined;
  loading?: number;
}) {
  const [isLoading, setIsLoading] = useState<number>(loading ?? 0);
  const [progress, setProgress] = useState(0);

  // Đồng bộ isLoading với loading prop
  useEffect(() => {
    setIsLoading(loading ?? 0);
    setProgress(0); // Reset progress mỗi khi loading thay đổi
  }, [loading]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isLoading > 0 && progress < 100) {
      interval = setInterval(() => {
        setProgress((prev) => {
          const newProgress = prev + 1;
          if (newProgress >= 100) {
            setIsLoading(0); // Reset isLoading khi progress đạt 100
            return 0; // Reset progress
          }
          return newProgress;
        });
      }, 5);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isLoading, progress]);

  const formCreate = (
    <Box
      className="flex-none"
      component="form"
      miw={w}
      mah={h === 0 ? 100 : h}
      maw={w === 0 ? 100 : w}
      mx="auto"
      style={{ textAlign: "center", margin: "0 auto" }}
    >
      <Image
        radius="md"
        src={img}
        style={{
          maxHeight: "110px",
        }}
      />
    </Box>
  );

  return (
    <>
      {isLoading > 0 && progress < 100 ? (
        <Flex justify={"center"} align={"center"}>
          <Progress value={progress} striped animated size={"lg"} w={300} />
        </Flex>
      ) : (
        formCreate
      )}
    </>
  );
};

export default ImageShow;
